import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../core/config/api.config';
import {INSTITUTE_SERVICE} from '../core/config/api.constants';
import {endpoint} from './path.constants';
import {ApiResponse} from './api-response.model';
import {InstituteType} from './enum/enum.model';


@Injectable({providedIn: 'root'})
export class InstituteService {
  private readonly baseUrl = ApiConfig.getBaseUrl(INSTITUTE_SERVICE);

  constructor(private http: HttpClient) {
  }

  getInstituteEnum() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<{ institution_type: InstituteType[] }>>(
      this.baseUrl + endpoint.institute.enum, {headers}
    );
  }

  register(payload: any) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.institute.register, payload, {headers}
    );
  }
}
